module.exports = __webpack_public_path__ + "img/stepper_marker_1.c37c32a9.svg";